function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "thumbs-hi-dark_svg__a",
  x1: 55.35,
  y1: 118.93,
  x2: 129.34,
  y2: 192.92,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M152.44 77.83a17.31 17.31 0 018.24 2.33c5.54 3 7.05 7 7.57 13.17.42 5.06-.22 7.28-2.73 9.29a1.57 1.57 0 00-.16 2.34 14.45 14.45 0 01.81 19.89 3.41 3.41 0 00-.28 4.08 14.46 14.46 0 01-2.45 18.67 5.55 5.55 0 00-1.71 5.77 9.64 9.64 0 01.48 3c0 8-8.5 19.5-22.5 19.5H46.25l-8-62.5 27-7s4 1 16.5-15c8.8-11.27 19.85-27.26 25.46-35.58a63.62 63.62 0 006.76-13.29 96.85 96.85 0 004.56-14.92 12.85 12.85 0 00.21-2.42 7.78 7.78 0 017.78-7.78 7.79 7.79 0 017.66 6.44c1.36 7.62 2.51 20.48-2.44 30.06 0 0-1.62 3.5-3.37 7.94a130.18 130.18 0 00-4.58 16.06z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M111.25 77.83h12.5l.47-2a116.49 116.49 0 014.11-14.07c1.75-4.44 3.38-7.94 3.38-7.94 5-9.58 3.8-22.44 2.44-30.06a7.72 7.72 0 00-8.66-6.37 7.79 7.79 0 016.66 6.37c1.36 7.62 2.51 20.48-2.44 30.06 0 0-1.62 3.5-3.37 7.94a116.45 116.45 0 00-4.11 14.06h-11a1 1 0 000 2zM166.17 124.85a14.45 14.45 0 00-.81-19.89 1.57 1.57 0 01.16-2.34c2.51-2 3.15-4.23 2.73-9.29-.52-6.21-2-10.17-7.57-13.17a17.31 17.31 0 00-8.24-2.33h-2a17.31 17.31 0 018.24 2.33c5.54 3 7.05 7 7.57 13.17.42 5.06-.22 7.28-2.73 9.29a1.57 1.57 0 00-.16 2.34 14.45 14.45 0 01.81 19.89 3.41 3.41 0 00-.28 4.08 14.46 14.46 0 01-2.45 18.67 5.55 5.55 0 00-1.71 5.77 9.64 9.64 0 01.48 3c0 3.65-1.78 8-5 11.71a23 23 0 01-15.47 5.79H46.25l-7.75-60.6-.25.06 8 62.5h93.46c14 0 22.5-11.49 22.5-19.5a9.64 9.64 0 00-.48-3 5.55 5.55 0 011.71-5.77 14.46 14.46 0 002.45-18.67 3.41 3.41 0 01.28-4.04z",
  opacity: 0.06
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M56.25 100h-24a8 8 0 00-8 8v43.81a24 24 0 0024 24h26V100z",
  fill: "#e90000"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 51.96,
  cy: 160,
  r: 7.67,
  fill: "#4a4d4e"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M48.25 173.83a24 24 0 01-24-24v2a24 24 0 0024 24h26v-2h-26z",
  opacity: 0.12
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M52 165.67a7.66 7.66 0 01-7.64-6.67 7.67 7.67 0 1015.19 0 7.66 7.66 0 01-7.55 6.67z",
  opacity: 0.12
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M74.26 100l74 74a25.55 25.55 0 01-7.65 1.5H74.1z",
  opacity: 0.2,
  fill: "url(#thumbs-hi-dark_svg__a)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h192v192H0z"
});

var SvgThumbsHiDark = function SvgThumbsHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "thums-up-hi",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

export default SvgThumbsHiDark;